/*
  About page root trail (sections/nr-about-story.liquid). Draws a wavy line
  through the seed markers down the lane on the left, grows it as the visitor
  scrolls, and sprouts each seed as the root reaches it. Visitors who prefer
  reduced motion get the whole trail at once.
*/
if (!customElements.get('nr-about-trail')) {
  class NrAboutTrail extends HTMLElement {
    connectedCallback() {
      this.guide = this.querySelector('.nr-about-trail__guide');
      this.root = this.querySelector('.nr-about-trail__root');
      this.markers = Array.from(this.querySelectorAll('.nr-about-marker'));
      if (!this.guide || !this.root || this.markers.length === 0) return;

      this.still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.points = [];
      this.length = 0;
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.onResize = () => this.draw();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this);
      }
      this.draw();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.observer) this.observer.disconnect();
    }

    draw() {
      const box = this.getBoundingClientRect();
      this.points = this.markers.map((marker) => {
        const rect = marker.getBoundingClientRect();
        return { x: rect.left - box.left + rect.width / 2, y: rect.top - box.top + rect.height / 2 };
      });

      // Start at the top of the story, then sway gently from seed to seed.
      const first = this.points[0];
      const sway = Math.max(0, Math.min(26, first.x - 6));
      let d = `M${first.x} 0 L${first.x} ${first.y}`;
      for (let i = 1; i < this.points.length; i++) {
        const a = this.points[i - 1];
        const b = this.points[i];
        const h = b.y - a.y;
        const s = i % 2 ? sway : -sway;
        d += ` C${a.x + s} ${a.y + h * 0.3} ${b.x - s} ${b.y - h * 0.3} ${b.x} ${b.y}`;
      }
      this.guide.setAttribute('d', d);
      this.root.setAttribute('d', d);
      this.length = this.root.getTotalLength();
      this.root.style.strokeDasharray = `${this.length}`;
      this.classList.add('is-drawn');
      this.update();
    }

    update() {
      const last = this.points[this.points.length - 1];
      if (!last) return;
      // The root's tip follows a line 60% of the way down the screen.
      const reach = this.still ? Infinity : window.innerHeight * 0.6 - this.getBoundingClientRect().top;
      const share = Math.max(0, Math.min(1, reach / last.y));
      this.root.style.strokeDashoffset = `${this.length * (1 - share)}`;
      this.markers.forEach((marker, i) => marker.classList.toggle('is-on', reach >= this.points[i].y - 4));
    }
  }

  customElements.define('nr-about-trail', NrAboutTrail);
}
